<template>
  <div class="brands-index-container">
    <PageHeadlineWithLink
      title="ブランド一覧"
      link-title="戻る"
      @click-link="onClickHeadlineLink"
    />
    <div class="brands__items-container">
      <div class="brands__items">
        <Loading v-if="isLoading" />
        <div v-else class="brands-boxes--connected">
          <div
            v-for="brand in brands"
            :key="brand.id"
            class="brands-box--connected"
          >
            <a :href="`/brands/${brand.id}`">
              <div class="brands-icon--connected">
                <img :src="brand.list_image_url" :alt="brand.screen_name" />
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="brands__pagination-container">
        <Pagination
          class="pagination"
          :current-page="currentPage"
          :total-pages="totalPages"
          @clicked="onClickPageLink"
        />
      </div>
    </div>
    <div class="brands-top-page__link">
      <p
        class="brands-back-to-top__link-text subhead"
        @click="onClickBackToTop"
      >
        ページトップへ ▲
      </p>
    </div>
  </div>
</template>

<script>
import Pagination from '../../organism/paginations/Pagination'
import PageHeadlineWithLink from '../../molecules/headlines/PageHeadlineWithLink'
import Loading from '../../atoms/loadings/Loading'
import axios from 'axios'
import url from 'url'
import qs from 'qs'

export default {
  components: {
    Pagination,
    PageHeadlineWithLink,
    Loading
  },
  data() {
    return {
      brands: [],
      currentPage: 1,
      totalPages: 0,
      isLoading: false
    }
  },
  mounted() {
    this.initializeParams()
    this.getBrands(this.currentPage)

    // NOTE: ブラウザバック・フォワード時の更新処理
    window.onpopstate = async function() {
      this.initializeParams()
      await this.getBrands(this.currentPage)
    }.bind(this)
  },
  methods: {
    initializeParams() {
      const urlQuery = url.parse(location.href).query
      if (!urlQuery) {
        this.currentPage = 1
        return
      }
      const parsed = qs.parse(urlQuery)
      this.currentPage = parsed.page ? Number(parsed.page) : 1
    },
    updateUrlFromParams() {
      history.pushState(
        '',
        '',
        this.currentPage <= 1 ? '/brands' : `/brands?page=${this.currentPage}`
      )
    },
    async getBrands(page) {
      this.isLoading = true
      try {
        const res = await axios.get(
          `/api/v1/pickup/brands?page=${page || 1}&limit=24`
        )
        const { current_page, total_pages } = res.data.meta
        this.currentPage = current_page
        this.totalPages = total_pages
        this.brands = res.data.data
          .map(brand => brand.attributes)
          .map(({ id, name, screen_name, list_image_url }) => ({
            id,
            name,
            screen_name,
            list_image_url
          }))
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.showableErrorFeedback = true
      }
      this.isLoading = false
    },
    async onClickPageLink(page) {
      this.onClickBackToTop()
      await this.getBrands(page)
      this.updateUrlFromParams()
    },
    onClickHeadlineLink() {
      window.history.back()
    },
    onClickBackToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
